export const openGoogleMap = (address: string): void => {
  if (!address) {
    console.error('Address is incorrect.');
    return;
  }

  const encodedAddress = encodeURIComponent(address);

  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  window.open(mapUrl, '_blank');
};
